<template>
  <div :class="ui.textSubheading" >
    <div v-if="data.model === 'STD'">
      {{data.type}}.{{data.stat}}.{{data.sec}} - Rev. {{data.rev}}
    </div>
    <div v-if="data.model === 'SMALL'" :class="ui.textDescription">
      {{data.type}}.{{data.stat}}.{{data.sec}} Rev. {{data.rev}}
    </div>
    <div v-if="data.model === 'REV'">
      {{data.rev}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [dateFunctions, apptheme],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getCurrentPage"]),
    ui() {
      return this.uiTheme1;
    }
  }
};
</script>
